export const STANDARD_INTERACTION_EVENT_TYPES = [
  'Chat',
  'Cloudgazing',
  'Photo_Taking',
  'Playing_Chess',
  'Cooking',
  'Eating',
  'Social_Invite',
  'Listening_Music',
  'Dancing',
  'Sleep',
  'Sell',
  'Letter',
  'Contact',
]

export function isStandardInteractionEvent(eventType) {
  return STANDARD_INTERACTION_EVENT_TYPES.includes(eventType)
}

export function isChoiceOrDeathEvent(eventType) {
  return eventType === 'Choice' || eventType === 'Death'
}

export function getEventRendererKind(eventType) {
  if (eventType === 'Moving_In') return 'moving-in'
  if (eventType === 'Family Interaction') return 'family-interaction'
  if (eventType === 'System_Sim_Status') return 'system-sim-status'
  if (isChoiceOrDeathEvent(eventType)) return 'choice-death'
  if (isStandardInteractionEvent(eventType)) return 'standard-interaction'
  return 'unknown'
}
